__turbopack_context__.v({
  "cta": "QuickAddTrigger-module-scss-module__-teYmq__cta",
  "iconButton": "QuickAddTrigger-module-scss-module__-teYmq__iconButton",
  "iconButtonInline": "QuickAddTrigger-module-scss-module__-teYmq__iconButtonInline",
});
